import { Box, Typography, Button, ListItem, Chip } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

// Ein Einladungs-Eintrag mit Annehmen/Ablehnen-Aktionen.
function EinladungItem({ einladung, onAccept, onDecline }) {
    return (
        <ListItem
            sx={{
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 2,
                py: 3,
            }}
        >
            <Box>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <GroupIcon color="primary" />
                    <Typography variant="h6">
                        {einladung.gruppen_name}
                    </Typography>
                    <Chip
                        label={`${einladung.mitglieder_anzahl} Mitglieder`}
                        size="small"
                        variant="outlined"
                    />
                </Box>

                {einladung.gruppen_beschreibung && (
                    <Typography variant="body2" color="text.secondary" mb={1}>
                        {einladung.gruppen_beschreibung}
                    </Typography>
                )}

                <Typography variant="body2" color="text.secondary">
                    Einladung von <strong>{einladung.einlader_name}</strong>
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {new Date(einladung.erstellt_am).toLocaleDateString('de-DE', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                    })}
                </Typography>
            </Box>

            <Box display="flex" gap={2}>
                <Button
                    variant="contained"
                    startIcon={<CheckIcon />}
                    onClick={() => onAccept(einladung.id)}
                    fullWidth
                >
                    Annehmen
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    startIcon={<CloseIcon />}
                    onClick={() => onDecline(einladung.id)}
                    fullWidth
                >
                    Ablehnen
                </Button>
            </Box>
        </ListItem>
    );
}

export default EinladungItem;
